import {Button, Figure, Alert, Badge, Tooltip, OverlayTrigger} from "react-bootstrap";
import {Link} from "react-router-dom";
import React from "react";
import {useProductFilteredList, useWindowSize} from "../../../hooks";
import {useBasket} from "../useShop";
import {useAlert, useAuth, useDarkMode} from "../../../context";
import {OurClearAlert, ProductCardLoading} from "../../_components";
import {config, scrollToTop} from "../../../utils2";
import {isDateInCurrentWeek} from "../../backend2/admin/utilities/readableDate";
import {UserPrice} from "./UserPrice";

export function ProductCardList() {

    const {list: productList, loadingList: productLoading, errorList: productError, clearErrorList: clearProductError} = useProductFilteredList("last_update", 4)

    return (<div className="d-flex w-100 justify-content-evenly flex-wrap gap-2">

            <OurClearAlert variant="danger" msg={productError} onClear={clearProductError}/>

            <ProductCardLoading show={productLoading}/>

            {productList.length > 0 ? (
                productList.map((item, index) => (
                    <div key={index} className="d-flex flex-grow-1">
                        <ProductCard item={item}/>
                    </div>
                ))
            ) : (
                <p>No products available.</p>
            )}
        </div>
    )
}

function ProductCard({item}) {
    const {addArticle, errorArticle, loadingArticle, clearErrorArticle} = useBasket(false)
    const {success} = useAlert()
    const {user} = useAuth()

    const {width} = useWindowSize()

    function handleSubmit(prodId, title) {
        addArticle(prodId, 1)
            .then(msg => {
                success(<span><strong>{title}</strong> has been added to your <Alert.Link as={Link} to="/shop/cart">Cart</Alert.Link>!</span>)
                scrollToTop()
            })
            .catch(console.warn)
    }

    const cardWidth = width < 576 ? "100%" : "260px"
    const cardHeight = width < 576 ? "100%" : "420px"

    return <>
        <OurClearAlert variant="danger" msg={errorArticle} onClear={clearErrorArticle}/>

        <div
            className="card border-0 bg-light-subtle mb-1"
            style={{width: cardWidth, height: cardHeight, overflow: 'hidden'}}
        >

            <div className="mb-0">
                {isDateInCurrentWeek(item.created_at) ? <Badge bg="info" pill>New</Badge> :
                    <Badge bg="transparent" pill style={{display: 'inline-block', width: 'auto', height: 'auto'}}></Badge>}
                {/*<Badge bg="danger" pill>Promo</Badge>*/}
            </div>


            <Figure className="d-flex justify-content-center"  style={{minWidth: '150px', minHeight: '150px'}}>
                <Link to={`/shop/detail/${item.id}`}>
                    <Figure.Image
                        src={config.get_public_media(item.medias[0].path, "thumb")}
                        alt={item.title}
                        rounded
                        height="150px"
                        width="150px"
                        loading="lazy"
                    />
                </Link>
            </Figure>

            <Link to={`/shop/detail/${item.id}`}
                  className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                <span className="text-wrap fw-bolder">{item.title}</span>
            </Link>

            <div className="text-wrap">
                {item.summary}
                {/*{truncateText(item.summary, 40)}*/}
            </div>

            <div className="d-flex flex-column mt-auto">
                {/*<div className="d-flex gap-2 my-2">*/}
                {/*    {item.tags.map(tag => <Link key={tag.id} to={`/shop/products?tags=${tag.id}`}*/}
                {/*                                className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-2 link-offset-2-hover">*/}
                {/*        <div className="fw-light">{tag?.name}</div>*/}
                {/*    </Link>)}*/}
                {/*</div>*/}

                <div className="d-flex justify-content-between align-items-center">
                    {/*<div className="fw-medium fs-5">€ {item.unit_price}</div>*/}
                    <UserPrice unitPrice={item.unit_price} vat={user?.vat_percentage}/>

                    {item.stock > 0 && <OverlayTrigger placement="top" overlay={<Tooltip>In stock</Tooltip>}>
                        <Button variant="success" className="" onClick={() => handleSubmit(item.id, item.title)} disabled={loadingArticle}>
                            {loadingArticle ? <i className="bi bi-three-dots"/> : <i className="bi bi-cart-plus"/>}
                        </Button>
                    </OverlayTrigger>}

                    {item.stock === 0 && item.is_available &&
                        <OverlayTrigger placement="top" overlay={<Tooltip>Backorder</Tooltip>}>
                            <Button variant="warning" className="" onClick={() => handleSubmit(item.id, item.title)} disabled={loadingArticle}>
                                {loadingArticle ? <i className="bi bi-three-dots"/> : <i className="bi bi-cart-plus"/>}
                            </Button>
                        </OverlayTrigger>}

                    {item.stock === 0 && !item.is_available && <OverlayTrigger placement="top" overlay={<Tooltip>Out of stock</Tooltip>}>
                        <span><Button variant="success" disabled><i className="bi bi-cart-plus"/></Button></span>
                    </OverlayTrigger>
                    }
                </div>
            </div>

        </div>

    </>
}

